<template>
  <div class="container" v-if="showBackButton">
    <div class="backbutton" @click="navigateBack">
      <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.21875 13.875L8.4375 13.6562C8.59375 13.5 8.59375 13.2812 8.4375 13.125L2.875 7.53125H14.625C14.8125 7.53125 15 7.375 15 7.15625V6.84375C15 6.65625 14.8125 6.46875 14.625 6.46875H2.875L8.4375 0.90625C8.59375 0.75 8.59375 0.53125 8.4375 0.375L8.21875 0.15625C8.0625 0 7.84375 0 7.6875 0.15625L1.09375 6.75C0.9375 6.90625 0.9375 7.125 1.09375 7.28125L7.6875 13.875C7.84375 14.0312 8.0625 14.0312 8.21875 13.875Z"
          fill="#00903C"
        />
      </svg>
      Vissza
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BackButton',
  computed: {
    ...mapGetters(['isAuthenticated', 'isModified', 'selectedUserCompany', 'selectedUserSoleProprietorship']),
    backButtonVisibility() {
      if (this.$route.path != '/' && this.$route.path != '/home' && this.$route.path != '/kkv-qualifier') return true
      else return false
    }
  },
  data() {
    return {
      route: 'test',
      showBackButton: false
    }
  },
  methods: {
    async navigateBack() {
      if (this.$route.name == 'CompetitionStepTwo' && this.isModified) {
        this.$root.$emit('bv::show::modal', 'goback-popup')
      } else if (this.$route.name == 'CompetitionStepThree' && this.isModified) {
        this.$root.$emit('bv::show::modal', 'goback-popup')
      } else if (this.$route.name == 'PrivateCompanyOffers') {
        const getCompanyQueryParams = { value: this.selectedUserCompany.companyId }
        await this.$store.dispatch('getCompany', getCompanyQueryParams)
        this.$store.commit('setSelectedUserCompany', this.selectedUserCompany)
        this.$router.push({
          name: 'CompanyDetails'
        })
      } else if (this.$route.name == 'CompanyDetails' && this.isAuthenticated) this.$router.push('/home')
      else if (this.$route.name == 'CompanyDetails' && !this.isAuthenticated) this.$router.push('/')
      else if (this.$route.name == 'CompetitionStepTwo') {
        const { competitionId } = this.$route.query
        this.$router.push(`/competitions/competition/1?competitionId=${competitionId}`)
      } else if (this.$route.name == 'PrivateSoleProprietorshipOffers') {
        const getSoleProprietorshipQueryParams = {
          userSoleProprietorshipId: this.selectedUserSoleProprietorship.id
        }
        await this.$store.dispatch('getUserSoleProprietorship', getSoleProprietorshipQueryParams)
        this.$store.commit('setSelectedUserSoleProprietorship', this.selectedUserSoleProprietorship)
        this.$router.push({
          name: 'SoleProprietorshipDetails'
        })
      } else if (this.$route.name == 'SoleProprietorshipDetails' && this.isAuthenticated) this.$router.push('/home')
      else if (this.$route.name == 'SoleProprietorshipDetails' && !this.isAuthenticated) this.$router.push('/')
      else this.$router.back()
    },
    competitionsSide: function() {
      return this.$route.path.includes('competitions')
    }
  },
  created() {
    if (this.backButtonVisibility) {
      this.showBackButton = true
    } else {
      this.showBackButton = false
    }
  },
  watch: {
    $route() {
      this.route = this.$route.path
      if (this.backButtonVisibility) {
        this.showBackButton = true
      } else {
        this.showBackButton = false
      }
    }
  }
}
</script>

<style scoped>
.backbutton svg {
  color: var(--color-green);
  font-size: 24px;
  margin-left: 0px;
  margin-right: 10px;
  cursor: pointer;
}
.backbutton {
  text-align: left;
  cursor: pointer;
  color: var(--color-green);
  width: 100px;
  margin-bottom: 25px;
}

.container-fluid--add {
  max-width: 100%;
  padding-right: 35px;
  padding-left: 35px;
  margin-right: auto;
  margin-left: auto;
}

@media (max-width: 993px) {
  .backbutton {
    margin-top: 6rem;
  }
}
</style>
